<template>
  <section>
    <div class="swpoll-qimage">
      <img :src="WEBHeaderImageURI" alt="header image" />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HeaderImage',
  props: {
  },
  computed: {
    ...mapState('poll', [
      'WEBHeaderImageURI'
    ]),
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  margin: 16px auto 0;
  z-index: 1;

  .swpoll-qimage {
    width: 80%;
    margin: 0 auto;
    img {
      margin-bottom: 12px;
      width: 100%;
      height: auto;
      max-height: var(--question-image-max-height);
      -o-object-fit: cover;
      object-fit: cover;
      -o-object-position: center;
      object-position: center;
      border-radius: 7px;
    }
  }
}
</style>
